import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";
import { AppTypography } from "../common/Typography";
import SupportPopup from "../common/SupportPopup";
import { useAuth } from "../../context/AuthContext";

const Footer = () => {
  const theme = useTheme();
  const [supportOpen, setSupportOpen] = useState(false);
  const { user: userData } = useAuth();

  const hasFooterText =
    typeof theme?.footer_text === "string" &&
    theme.footer_text.trim().length > 0;

  const handleSupportClose = () => {
    setSupportOpen(false);
  };

  // If there's no footer text from backend, hide footer entirely
  if (!hasFooterText) return null;

  return (
    <>
      <Box
        component="footer"
        sx={{
          backgroundColor: theme?.background_color,
          borderTop: `1px solid ${theme?.divider}`,
          py: 2,
          mt: "auto",
          position: "relative",
          bottom: 0,
          width: "100%",
          zIndex: 1,
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: theme?.text_color,
                fontSize: "0.9rem",
                textAlign: "center",
              }}
            >
              {theme?.footer_text}
            </Typography>
            {/* {userData?.id ? (
              <Box sx={{ textAlign: "center" }}>
                <AppTypography
                  variant="body2"
                  style={theme?.typography?.body}
                  fontSize="0.875rem"
                  textAlign="center"
                  sx={{ opacity: 0.7 }}
                >
                  Need help?{" "}
                  <AppTypography
                    component="button"
                    type="button"
                    onClick={() => setSupportOpen(true)}
                    style={theme?.typography?.link}
                    fontSize="0.875rem"
                    fontWeight={600}
                    sx={{
                      textDecoration: "none",
                      cursor: "pointer",
                      border: "none",
                      background: "none",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    Contact Support
                  </AppTypography>
                </AppTypography>
              </Box>
            ) : null} */}
          </Box>
        </Container>
      </Box>
      <SupportPopup open={supportOpen} onClose={handleSupportClose} />
    </>
  );
};

export default Footer;
